import { siteConfig } from '@/constants/site'

// Base address of the published site without trailing slash. The "webseite" field in the CMS
// settings wins over the default from siteConfig; https is added when the protocol is missing.
export const resolveSiteUrl = (siteUrl?: string | null): string => {
    const value = siteUrl && siteUrl.trim() !== '' ? siteUrl.trim() : siteConfig.url
    const withProtocol = /^https?:\/\//i.test(value) ? value : `https://${value}`

    return withProtocol.replace(/\/+$/, '')
}
